import InventarioPagina from "./InventarioPagina";

export default InventarioPagina;